import styled from 'styled-components'
import { FileShareRefresh } from './FileShareRefresh'

export const FileShareHeader = () => {
  return (
    <Div data-testid="claims-page-header">
      <h1>File Share</h1>

      <div className="refresh_holder">
        <FileShareRefresh />
      </div>
    </Div>
  )
}

const Div = styled.div`
  height: ${({ theme }) => theme.constants.pageTitleHeight};
  display: inline-flex;
  width: 100%;
  align-items: center;
  padding: 0rem ${({ theme }) => theme.spacing.l};
  background: ${({ theme }) => theme.colors.neutral.lighter};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey.lighter};
  margin-bottom: ${({ theme }) => theme.spacing.l};
  .refresh_holder {
    margin-left: auto;
  }
  h1 {
    ${({ theme }) => theme.typography.h4.bold};
    color: ${({ theme }) => theme.colors.primary.neutral};
    padding-block: 0.75rem;
    white-space: nowrap;
  }

  div {
    margin-left: 0.25rem;
    float: left;
    svg {
      color: ${({ theme }) => theme.colors.grey.light};
    }
    .text {
      margin-bottom: 0.1rem;
      ${({ theme }) => theme.typography.s.normal};
    }
  }
`
